module.exports = __webpack_public_path__ + "img/forgiveness-trailer-btn.02f755a3.png";